package com.wintermar.inspection.feature.presentation.inspection.widget

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.runtime.Composable
import androidx.compose.runtime.derivedStateOf
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.unit.dp
import com.wintermar.inspection.core.ui.component.TextBodySmall
import com.wintermar.inspection.core.ui.component.button.InputButton
import com.wintermar.inspection.core.ui.component.image.Document
import com.wintermar.inspection.core.ui.component.image.util.FileGroupTypes
import com.wintermar.inspection.core.ui.component.image.util.FileUtil
import com.wintermar.inspection.core.ui.theme.AppDimension
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import com.wintermar.inspection.core.ui.theme.color.model.ThemeColor
import com.wintermar.inspection.core.ui.widget.ImageGrid
import com.wintermar.inspection.feature.domain.model.answer.AnswerFileModel
import com.wintermar.inspection.feature.util.finding_category.FindingCategoryView
import com.wintermar.inspection.graphql.type.FindingCategory
import inspection.composeapp.generated.resources.Res
import inspection.composeapp.generated.resources.category
import inspection.composeapp.generated.resources.files
import inspection.composeapp.generated.resources.notes
import org.jetbrains.compose.resources.stringResource

@Composable
fun NotesPhotoView(
    notes: String = "",
    files: List<AnswerFileModel> = listOf(),
    showFindingCategory: Boolean,
    findingCategory: FindingCategory,
    dimension: AppDimension = LocalAppTheme.current.dimension,
    color: ThemeColor = LocalAppTheme.current.color
) {
    val imageFiles by remember(files) {
        derivedStateOf {
            files.filter {
                FileGroupTypes.IMAGES.getExtensionsWithoutDot()
                    .contains(FileUtil.getExtensionFromFileName(it.name))
            }
        }
    }
    val documentFiles by remember(files) {
        derivedStateOf {
            files.filter {
                FileGroupTypes.DOCUMENTS.getExtensionsWithoutDot()
                    .contains(FileUtil.getExtensionFromFileName(it.name))
            }
        }
    }

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .clip(RoundedCornerShape(dimension.radius.md))
            .background(color.surface.neutral.subtlest.default)
            .border(
                width = 1.dp,
                color = color.border.subtle,
                shape = RoundedCornerShape(dimension.radius.md)
            )
            .padding(dimension.spacing.space3),
        verticalArrangement = Arrangement.spacedBy(
            space = dimension.spacing.space4
        ),
    ) {
        if (notes.isNotEmpty()) {
            Column(
                modifier = Modifier.fillMaxWidth(),
                verticalArrangement = Arrangement.spacedBy(
                    space = dimension.spacing.space1
                )
            ) {
                TextBodySmall(
                    text = stringResource(Res.string.notes),
                    color = { it.subtle }
                )

                TextBodySmall(
                    text = notes,
                )
            }
        }

        if (files.isNotEmpty()) {
            Column(
                modifier = Modifier.fillMaxWidth(),
                verticalArrangement = Arrangement.spacedBy(
                    space = dimension.spacing.space1
                )
            ) {
                TextBodySmall(
                    text = stringResource(Res.string.files),
                    color = { it.subtle }
                )
                ImageGrid(
                    files = imageFiles.map { file ->
                        file.toFileModel()
                    },
                    modifier = Modifier.fillMaxWidth()
                )

                documentFiles.forEach {
                    Document(
                        file = it.toFileModel()
                    )
                }
            }
        }

        if (showFindingCategory) {
            Column(
                modifier = Modifier.fillMaxWidth(),
                verticalArrangement = Arrangement.spacedBy(
                    space = dimension.spacing.space1
                )
            ) {
                TextBodySmall(
                    text = stringResource(Res.string.category),
                    color = { it.subtle }
                )
                InputButton(
                    disabledClick = true,
                    modifier = Modifier.fillMaxWidth(),
                    onClick = {} // no-op
                ) {
                    FindingCategoryView(
                        category = findingCategory,
                        showDescription = false,
                        bold = false
                    )
                }
            }
        }
    }
}
